// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ezH6S9wTxvqLqrG_OACEK"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Ready/styles.css
// module id = 2888
// module chunks = 0